
export const AcceptedImageTypes = ".png,.jpg,.jpeg,.gif"
